var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.016 26.3301C11.7486 26.6228 11.4137 26.7692 11.0114 26.7692C10.6103 26.7692 10.2754 26.6228 10.0069 26.3301L1.26857 17.55C1.08914 17.3702 1 17.1615 1 16.9252C1 16.6889 1.08914 16.4918 1.26857 16.3339C1.424 16.1541 1.61943 16.0642 1.85371 16.0642C2.088 16.0642 2.29486 16.1541 2.47314 16.3339L11.0114 24.9457L29.5611 6.2363C29.7166 6.07954 29.9177 6 30.1634 6C30.4091 6 30.6103 6.07954 30.7657 6.2363C30.9223 6.41728 31 6.62476 31 6.86106C31 7.09736 30.9223 7.29563 30.7657 7.45239L12.016 26.3301Z"}));
}

Check.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","className":"icon"};

module.exports = Check;

Check.default = Check;
